import { render, staticRenderFns } from "./ChatLive.vue?vue&type=template&id=84f980ec&scoped=true&"
import script from "./ChatLive.vue?vue&type=script&lang=js&"
export * from "./ChatLive.vue?vue&type=script&lang=js&"
import style0 from "./ChatLive.vue?vue&type=style&index=0&id=84f980ec&prod&lang=scss&scoped=true&"
import style1 from "./ChatLive.vue?vue&type=style&index=1&id=84f980ec&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84f980ec",
  null
  
)

export default component.exports